export const MAX_FILE_COUNT = 5;
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_FILE_SIZE_LABEL = '10 MB';

export const SUPPORTED_FILE_EXTENSIONS = [
  'doc',
  'docx',
  'pptx',
  'pdf',
  'txt',
  'md',
];

const SUPPORTED_MIME_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/pdf',
  'text/plain',
];

export const FILE_INPUT_ACCEPT = SUPPORTED_MIME_TYPES.concat(
  SUPPORTED_FILE_EXTENSIONS.map((extension) => `.${extension}`)
).join(',');
